

<div class="px-0 mx-0 container-fluid">
    <app-navbar></app-navbar>
    <!-- <app-navbar-preview></app-navbar-preview> -->

    <router-outlet></router-outlet>

</div>